'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

var _graphql = require('graphql');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _QueryBuilder = require('./components/QueryBuilder');

var _QueryBuilder2 = _interopRequireDefault(_QueryBuilder);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var App = (_temp2 = _class = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _this.fetcher = function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee(props) {
        var query, other, client;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = props.query, other = _objectWithoutProperties(props, ['query']);
                client = _this.context.client;
                _context.next = 4;
                return client.initQueryManager().query(_extends({
                  query: (0, _graphqlTag2.default)(query)
                }, other)).catch(function (error) {
                  console.error(error);
                  throw error;
                });

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  } // static contextTypes = {
  //   client: PropTypes.object.isRequired,
  // }
  // static childContextTypes = {
  //   schema: PropTypes.object,
  // }
  // getChildContext() {
  //   return {
  //     schema: this.getSchema(),
  //   }
  // }
  // constructor(props) {
  //   super(props);
  //   // const schema = this.getSchema();
  //   const {
  //     data,
  //   } = props;
  //   const clientSchema = buildClientSchema(data);
  //   // console.log("clientSchema", { ...clientSchema });
  //   // console.log("clientSchema data", { ...data });
  //   this.state = {
  //     ...this.state,
  //     clientSchema,
  //   }
  // }


  App.prototype.componentWillMount = function componentWillMount() {
    this.initSchema();
    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };

  App.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var clientSchema = this.state.clientSchema;

    if (!clientSchema) {
      clientSchema = this.buildClientSchema();

      if (clientSchema) {
        this.setState({
          clientSchema: clientSchema
        });
      }
    }

    _Component.prototype.componentDidUpdate && _Component.prototype.componentDidUpdate.call(this, prevProps, prevState);
  };

  App.prototype.initSchema = function initSchema() {
    var clientSchema = this.buildClientSchema();

    if (clientSchema) {
      Object.assign(this.state, {
        clientSchema: clientSchema
      });
    }
  };

  App.prototype.buildClientSchema = function buildClientSchema() {
    var clientSchema = void 0;
    var schema = this.getSchema();

    if (schema) {
      clientSchema = (0, _graphql.buildClientSchema)({
        __schema: schema
      });
    }

    return clientSchema;
  };

  App.prototype.getSchema = function getSchema() {
    // const {
    //   data: {
    //     __schema: schema,
    //   }
    // } = this.props;
    var schema = this.context.schema;
    return schema;
  };

  App.prototype.render = function render() {
    // const schema = this.getSchema();
    // if (!schema) {
    //   return null;
    // }
    var _props = this.props,
        defaultQuery = _props.defaultQuery,
        query = _props.query,
        fetcher = _props.fetcher,
        other = _objectWithoutProperties(_props, ['defaultQuery', 'query', 'fetcher']);

    var clientSchema = this.state.clientSchema;

    if (!clientSchema) {
      return null;
    } // return "null";


    return _react2.default.createElement(_QueryBuilder2.default, _extends({
      schema: clientSchema,
      fetcher: fetcher || this.fetcher,
      defaultQuery: defaultQuery,
      view: [// UsersView,
      ],
      query: query // onEditQuery={query => {
      //   console.log("onEditQuery", query);
      // }}

    }, other));
  };

  return App;
}(_react.Component), _class.defaultProps = {
  defaultQuery: ''
}, _class.contextType = _context3.default, _temp2);
exports.default = App;
App.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultQuery: _propTypes2.default.string.isRequired,
  query: _propTypes2.default.string,
  fetcher: _propTypes2.default.func,
  onEditQuery: _propTypes2.default.func
} : {};
module.exports = exports['default'];